<app-str-spinner [message]="spinnerMessage"></app-str-spinner>
<group-period-report [periodType]="periodType"></group-period-report>